import React from 'react';
import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { StateAidAdditionalInfoSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidAdditionalInfoSection.tsx';
import { StateAidApplicationsSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidApplicationsSection.tsx';
import { StateAidGeneralInfoSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidGeneralInfoSection.tsx';
import { StateAidReceivedHistorySection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/StateAidReceivedHistorySection.tsx';
import { useStateAidReceivedForm } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/useStateAidReceivedForm.ts';
import type { TDocumentGenerationFormProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/types.ts';
import { HistoricalPrefillProvider } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/historicalPrefill/HistoricalPrefillProvider.tsx';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { useDocumentGenerationFormSubmission } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/hooks/useDocumentGenerationFormSubmission.ts';

export const StateAidReceivedDocumentGenerationForm: React.FC<TDocumentGenerationFormProps> = ({
  disabled,
  formId,
  onDirtyChange,
  onHistoricalPrefillPendingFieldsChange,
  onSaveAttemptChange,
  onValidationIssuesChange,
  ...formParams
}) => {
  const { config, form, historicalFields, isLoading, quarterWindow, handleSubmit } =
    useStateAidReceivedForm(formParams);
  const agricultural = form.watch('agricultural');
  const isFormDisabled = disabled || isLoading;
  const { attemptSave } = useDocumentGenerationFormSubmission({
    form,
    onDirtyChange,
    onSaveAttemptChange,
    onValidationIssuesChange,
    onValidSubmit: handleSubmit,
  });

  return (
    <FormProvider {...form}>
      <HistoricalPrefillProvider
        fieldNames={historicalFields}
        onPendingFieldsChange={onHistoricalPrefillPendingFieldsChange}
      >
        <Box
          component="form"
          id={formId}
          noValidate
          onSubmit={(event) => {
            event.preventDefault();
            attemptSave();
          }}
          sx={documentGenerationFormStyles.form}
        >
          <StateAidGeneralInfoSection title={config.title} disabled={isFormDisabled} />
          <StateAidReceivedHistorySection
            programName={config.programName}
            disabled={isFormDisabled}
            quarters={quarterWindow}
          />
          <StateAidApplicationsSection
            disabled={isFormDisabled}
            includesCovidSection={config.includesCovidSection}
          />
          <StateAidAdditionalInfoSection
            agricultural={agricultural}
            disabled={isFormDisabled}
            includesCovidSection={config.includesCovidSection}
          />
        </Box>
      </HistoricalPrefillProvider>
    </FormProvider>
  );
};
